// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Speakers/speaker.scss
// module id = 590
// module chunks = 0